<template>
  <Navbar />
  <ScrollButton />

  <section class="banner-title" style="background-image: url(images/arge-blur.png);">
    <div class="auto-container">
      <div class="row clearfix d-flex align-items-center justify-content-between" style="flex-wrap: nowrap;">">
        <div class="col-auto text-start">
          <h1>AR-GE</h1>
        </div>
        <div class="col-auto text-end">
          <ul class="bread-crumb clearfix" aria-label="breadcrumb" style="margin: 0;">
            <li><a href="/">Anasayfa</a></li>
            <li class="active" aria-current="page">AR-GE</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="page-section" id="portfolio">
    <div class="container">
      <div class="text-uppercase line-wrapper text-center">
        <div class="line"></div>
        <h2 class="text">AR-GE Çalışmalarımız</h2>
        <div class="line"></div>
      </div>

      <div class="row">
        <div class="col-12 text-center mb-5">
          <h3 class="section-subtitle">Yenilikçi Elektronik Tasarım ve Prototipleme</h3>
          <p>
            Kontrol kartları, sensör çözümleri ve otomasyon sistemleri üzerinde Ar-Ge çalışmaları yürütüyor;
            projelere özel elektronik tasarımlar geliştiriyoruz.
          </p>
        </div>
      </div>

      <div class="row justify-content-center image-gallery">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-10 mb-4"
          v-for="(item, index) in arges"
          :key="index"
        >
          <div class="portfolio-item">
            <a
              class="portfolio-link"
              data-bs-toggle="modal"
              :href="'#portfolioModal' + index"
            >
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
              <img class="img-fluid" :src="item.logo" :alt="item.baslik || 'Arge Projesi'" loading="lazy" decoding="async" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <Footer />

  <!-- Modal galerisi -->
  <div
    class="portfolio-modal modal fade"
    v-for="(item, index) in arges"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-bs-dismiss="modal">
          <img src="images/close-icon.svg" alt="Kapat" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="modal-body">
               <img :src="item.logo" :alt="item.baslik || 'Arge Projesi'" style="max-width: 100%; height: auto; border-radius: 8px;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

useHead({
  title: 'AR-GE | İntek Electronic',
  meta: [
    {
      name: 'description',
      content: 'İntek Electronic’in AR-GE çalışmaları kapsamında geliştirdiği kontrol kartları, sensör çözümleri ve otomasyon sistemlerini keşfedin.'
    },
    {
      name: 'keywords',
      content: 'AR-GE, elektronik tasarım, kontrol kartı, sensör, otomasyon, intek electronic, pcb geliştirme, bilişim vadisi'
    },
    {
      property: 'og:title',
      content: 'AR-GE | İntek Electronic'
    },
    {
      property: 'og:description',
      content: 'İntek Electronic’in Ar-Ge faaliyetleriyle yenilikçi elektronik sistem çözümlerine ulaşın.'
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/arge-blur.png'
    },
    {
      property: 'og:url',
      content: 'https://www.intekelectronic.com.tr/arge'
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.intekelectronic.com.tr/arge'
    }
  ]
});


const arges = ref([]);

onMounted(async () => {
  const q = query(collection(firestore, "arge"), where("durum", "==", true));
  const querySnapshot = await getDocs(q);
  const veri = [];
  querySnapshot.forEach((doc) => {
    veri.push({ ...doc.data(), id: doc.id });
  });
  arges.value = veri;
});
</script>

<style scoped>
.portfolio-item {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.portfolio-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  border-radius: 4px;
}

.portfolio-item:hover img {
  transform: scale(1.05);
}

.portfolio-hover {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.portfolio-link:hover .portfolio-hover {
  opacity: 1;
}

.portfolio-hover-content {
  color: #fff;
  font-size: 2rem;
}

.image-gallery {
  justify-content: center;
  text-align: center;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
.section-subtitle {
  color: #000;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}
.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}
.modal-content {
  max-width: 800px;
  margin: auto;
}
@media (max-width: 768px) {
  .portfolio-item {
    aspect-ratio: 1 / 1;
  }
  .section-subtitle {
    font-size: 18px;
  }
}
</style>